"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handlers = void 0;
exports.onFederatedMsg = onFederatedMsg;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _packingSlips = require("./packingSlips");
var _state = require("./state");
var _filters = require("./filters");
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
var _sendQueue = _interopRequireDefault(require("./sendQueue"));
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var extend = _lodashReplacement.default.extend,
  without = _lodashReplacement.default.without;
var handlers = {
  "federation.ping": function federationPing(data /*, callback */) {
    data.source.setInstanceId(data.packingSlip.instanceId);
    if (data.source.handshakeComplete) {
      data.source.sendPong(data.packingSlip);
    } else {
      data.source.sendBundle([(0, _packingSlips.getPackingSlip)("pong", data.packingSlip), (0, _packingSlips.getPackingSlip)("ping")]);
    }
  },
  "federation.pong": function federationPong(data) {
    data.source.handshakeComplete = true;
    data.source.setInstanceId(data.packingSlip.instanceId);
    if (data.source.pings[data.packingSlip.pingData.ticket]) {
      data.source.pings[data.packingSlip.pingData.ticket].callback({
        ticket: data.packingSlip.pingData.ticket,
        instanceId: data.packingSlip.instanceId,
        source: data.source
      });
      data.source.pings[data.packingSlip.pingData.ticket] = undefined;
    }
    if (!_state.state._clients.includes(data.packingSlip.instanceId)) {
      _state.state._clients.push(data.packingSlip.instanceId);
    }
    _mttPostal.default.publish({
      channel: "postal.federation",
      topic: "client.federated",
      data: {
        remoteId: data.source.instanceId,
        localId: _mttPostal.default.instanceId(),
        transport: data.transport
      }
    });
    (0, _sendQueue.default)();
  },
  "federation.disconnect": function federationDisconnect(data) {
    _state.state._clients = without(_state.state._clients, data.source.instanceId);
    (0, _state.disconnect)({
      transport: data.source.transportName,
      instanceId: data.source.instanceId,
      doNotNotify: true
    });
  },
  "federation.message": function federationMessage(data) {
    var env = data.packingSlip.envelope;
    if ((0, _filters.matchesFilter)(env.channel, env.topic, "in")) {
      env.lastSender = data.packingSlip.instanceId;
      _mttPostal.default.publish(env);
    }
  },
  "federation.bundle": function federationBundle(data) {
    data.packingSlip.packingSlips.forEach(function (slip) {
      onFederatedMsg(extend({}, data, {
        packingSlip: slip
      }));
    });
  }
};
exports.handlers = handlers;
function onFederatedMsg(data) {
  if (!_state.state._ready) {
    _state.state._inboundQueue.push(data);
    return;
  }
  if (Object.prototype.hasOwnProperty.call(handlers, data.packingSlip.type)) {
    handlers[data.packingSlip.type](data);
  } else {
    throw new Error("postal.federation does not have a message handler for '" + data.packingSlip.type + "'.");
  }
}